export const realtorData = {
  email: 'habitacionalasesoria@unne.cl',
  phone: '990102080'
  // email: 'contacto@accionpanal.com',
};
